module.exports = __webpack_public_path__ + "img/layout-9_2.aa299863.png";